import ChapterCard from "./ChapterCard";

export default ChapterCard;
